import { Component, OnInit } from '@angular/core';
import { ResiduesService } from '../../../../services/residues.service';
import { UsersService } from '../../../../services/users.service';
import * as M from '../../../../../styles/materialize/js/materialize.min.js';
import { IAddResiduesForm } from 'src/app/interfaces';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';


@Component({
  selector: 'app-cadastro-residuos',
  templateUrl: './cadastro-residuos.component.html',
  styleUrls: ['./cadastro-residuos.component.css']
})
export class CadastroResiduosComponent implements OnInit {
  constructor(
    private usersService: UsersService,
    private residuesService: ResiduesService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  isUploading: boolean = false;

  addResiduesForm: IAddResiduesForm = {
    cnpj: localStorage.getItem('cnpj'),
    phone: "",
    email: localStorage.getItem('email'),
    name: "",
    type: [],
    sector: [],
    imagePath: "",
    description: ""
  };
  pathImage: string;
  options = {};

  ngOnInit(): void {
    M.Sidenav.init(document.querySelectorAll('.sidenav'), this.options);
    M.FormSelect.init(document.querySelectorAll('select'), this.options);
  }

  upload(event: any): void {
    this.isUploading = true;
    const image: File = event.target.files[0];
    this.residuesService.uploadResidueImage(image).subscribe((uploadedImage:any) => {
      this.addResiduesForm.imagePath = uploadedImage.fileInfo.name;
      this.isUploading = false;
    })
  }

  addSector(event: any){
    if(this.addResiduesForm.sector.includes(event.target.value)){
      this.addResiduesForm.sector = this.addResiduesForm.sector.filter(sector => sector !== event.target.value)
    }else{
      this.addResiduesForm.sector.push(event.target.value);
    }
  }

  addType(event: any){
    if(this.addResiduesForm.type.includes(event.target.value)){
      this.addResiduesForm.type = this.addResiduesForm.type.filter(type => type !== event.target.value)
    }else{
      this.addResiduesForm.type.push(event.target.value);
    }
  }

  hasEmptyFields = () => this.addResiduesForm.name === "" || this.addResiduesForm.description === "" || this.addResiduesForm.type.length === 0 || this.addResiduesForm.sector.length === 0 || this.addResiduesForm.imagePath === "";

  onSubmit() {
    if(this.hasEmptyFields()) {
      this.snackBar.open("Todos os campos são obrigatórios! Preencha todos.", "Fechar", {
          duration: 7000,
        });
    } else {
      this.residuesService.addResidue(this.addResiduesForm).subscribe(
        () => {
          this.snackBar.open("O resíduo foi cadastrado com sucesso", "Fechar", {
            duration: 7000,
          });
          this.router.navigate(['/painel-pessoa-juridica']);
        },
        () => {
          this.snackBar.open("Não foi possível cadastrar o resíduo, por favor tente mais tarde", "Fechar", {
            duration: 7000,
          })
        }
      )
    }
  }

  logout() {
    this.usersService.logout();
  }
}